import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={footerStyle}>
      <div style={sectionStyle}>
        <h3 style={{ marginBottom: "10px" }}>MotoHub India</h3>
        <p style={mutedTextStyle}>
          India's biker community and smart tools platform for riders who plan,
          compare, and explore with confidence.
        </p>
      </div>

      <div style={sectionStyle}>
        <h4 style={headingStyle}>Explore</h4>
        <Link to="/about" style={linkStyle}>About</Link>
        <Link to="/feedback" style={linkStyle}>Feedback</Link>
        <Link to="/blogs" style={linkStyle}>Blogs</Link>
      </div>

      <div style={sectionStyle}>
        <h4 style={headingStyle}>Creator</h4>
        <p>Shailesh Kamble</p>
        <a href="https://www.youtube.com/@Shailesh_sk7" style={linkStyle}>
          Shailesh_sk7 Youtube  
        </a>
        <p style={mutedTextStyle}>Pune, India</p>
      </div>

      <div style={sectionStyle}>
        <h4 style={headingStyle}>Contact</h4>
        <a href="mailto:shaileshkamble771995@gmail.com" style={linkStyle}>
          shaileshkamble771995@gmail.com
        </a>
        <a
          href="https://www.linkedin.com/in/shailesh-kamble-4257651b2/"
          target="_blank"
          rel="noreferrer"
          style={linkStyle}
        >
          LinkedIn
        </a>
        <a
          href="https://www.instagram.com/shailesh_sk7/?hl=en"
          target="_blank"
          rel="noreferrer"
          style={linkStyle}
        >
          Instagram
        </a>
      </div>

      <div style={footerBottomStyle}>
        Copyright 2026 MotoHub India. Built by Shailesh Kamble.
      </div>
    </footer>
  );
}

const footerStyle = {
  marginTop: "50px",
  padding: "30px",
  background: "#0d0d0d",
  borderTop: "1px solid #222",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: "20px",
  color: "#fff",
};

const sectionStyle = {
  fontSize: "14px",
  display: "grid",
  gap: "8px",
};

const headingStyle = {
  marginBottom: "6px",
};

const mutedTextStyle = {
  color: "#A7A19A",
  lineHeight: 1.7,
};

const linkStyle = {
  color: "#F0EDE8",
  textDecoration: "none",
};

const footerBottomStyle = {
  gridColumn: "1 / -1",
  marginTop: "8px",
  color: "#777",
  fontSize: "12px",
  borderTop: "1px solid #222",
  paddingTop: "16px",
};
